var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c("DimensionSelector", {
        ref: "dimensionSelector",
        attrs: {
          valueName: _vm.item.name,
          valueWidth: _vm.item.width,
          valueDrop: _vm.item.drop,
          type: this.item.type
        },
        on: {
          room: function($event) {
            return _vm.setRoom($event)
          },
          ready: function(isReady) {
            return (_vm.readyToSubmitDimension = isReady)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _vm.$v.item.$error && !_vm.$v.item.total.required
            ? _c("div", { staticClass: "red--text" }, [
                _vm._v("Please enter Price")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$v.item.$error && !_vm.$v.item.total.decimal
            ? _c("div", { staticClass: "red--text" }, [
                _vm._v("Please enter correct price")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: { label: "Price" },
            model: {
              value: _vm.item.total,
              callback: function($$v) {
                _vm.$set(_vm.item, "total", $$v)
              },
              expression: "item.total"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-textarea", {
        attrs: { name: "notes", label: "Line Item Notes" },
        model: {
          value: _vm.item.notes,
          callback: function($$v) {
            _vm.$set(_vm.item, "notes", $$v)
          },
          expression: "item.notes"
        }
      }),
      _vm._v(" "),
      !_vm.edit
        ? _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Add Misc Item")]
          )
        : _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Update " + _vm._s(_vm.item.type))]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71525112", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71525112","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Misc.vue
// module id = null
// module chunks = 